import DownloadPopup from "components/core/modal-components/DownloadPopup";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CF_URLS } from "services/api/endpoints";
import { selectAuth } from "store/slices";
import { ERROR_TYPES, downloadOptionPdf } from "utils/constants";
import {
  dataDogErrorLog,
  findErrorMessage,
  getUserName,
  handleRefId,
  printReport
} from "utils/helpers";

export default function DownloadReportModal({
  isVisible,
  setIsVisible,
  printRequestBody,
  setIsLoading,
  throwError,
  setThrowError,
  throwErrorMessage,
  setThrowErrorMessage,
  reportCFUrl,
  setReportCFUrl
}) {
  const { auth } = useSelector(selectAuth);
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(downloadOptionPdf);

  //handle download
  const handleDownload = async () => {
    try {
      setIsLoading(true);
      setThrowError(false);
      const reqBody = JSON.stringify({
        main_district_id: printRequestBody.main_district_id,
        district_id: printRequestBody.district_id,
        bill_cycle_code: printRequestBody.bill_cycle_code,
        bill_catalog_code: printRequestBody.bill_catalog_code,
        cust_parent_id: printRequestBody.cust_parent_id,
        cust_id: printRequestBody.cust_id,
        bill_class_code: printRequestBody.bill_class_code,
        catalog_item_code: printRequestBody.catalog_item_code,
        manual_sort: printRequestBody.manual_sort,
        counted_item_flag: printRequestBody.counted_item_flag,
        currency_symbol: "",
        user_name: getUserName(auth?.user),
        report_format: selectedValue?.type?.toUpperCase()
      });
      let reportResponse = await printReport(
        reqBody,
        `${CF_URLS.printReports.billing.billingTransactionsReport}`
      );
      if (!reportResponse.success) {
        setThrowErrorMessage(reportResponse.error);
        setThrowError(true);
      }
    } catch (error) {
      const { refId, message } = handleRefId(
        error.message || findErrorMessage(ERROR_TYPES.ISSUE)
      );
      setThrowErrorMessage(message);
      setThrowError(true);
      dataDogErrorLog(
        message,
        CF_URLS.printReports.billing.billingTransactionsReport,
        {
          error
        },
        refId
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setThrowError(false);
    setIsVisible(false);
    setReportCFUrl("");
  };

  return (
    <DownloadPopup
      title={t("billingTransactions.billingTransactionReport")}
      showPrintModal={isVisible}
      cfUrl={reportCFUrl}
      onCancleClick={handleCancel}
      onDownloadClick={handleDownload}
      setSelectedValue={setSelectedValue}
      setThrowError={setThrowError}
      throwError={throwError}
      throwErrorMessage={throwErrorMessage}
    />
  );
}
